import { Component, OnInit, ChangeDetectionStrategy, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-locker-block',
  templateUrl: './locker-block.component.html',
  styleUrls: ['./locker-block.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockerBlockComponent implements OnInit {
  @Input() disabled?: boolean = false;
  @Input() locked: boolean = false;
  @Input() text?: string = 'Функционал доступен в другом тарифе';

  // @ContentChild('button', { static: true }) button!: ButtonComponent ;

  constructor(
    private _router: Router,
    private _elementRef: ElementRef,
  ) {}

  ngOnInit(): void {}

  redirectTo() {
    this._router.navigateByUrl(`private-office/tariffs-and-payment`);
  }
}
